import { useState, useRef, useEffect } from "react";
import { MessageCircle, X, Send, Sparkles, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function SupportBot() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    { role: "Concierge", text: "Hi! 👋 I'm your Miss United States of Africa concierge. Ask me about voting, tickets, events or your favourite candidate!" },
  ]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const sidRef = useRef(localStorage.getItem("musa_support_sid") || null);
  const endRef = useRef(null);

  useEffect(() => { if (open) endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, open]);

  const send = async (e) => {
    e.preventDefault();
    const text = input.trim();
    if (!text || sending) return;
    setInput("");
    setMsgs((m) => [...m, { role: "Fan", text }]);
    setSending(true);
    try {
      const { data } = await api.post("/support/chat", { message: text, session_id: sidRef.current });
      sidRef.current = data.session_id;
      localStorage.setItem("musa_support_sid", data.session_id);
      setMsgs((m) => [...m, { role: "Concierge", text: data.reply }]);
    } catch {
      setMsgs((m) => [...m, { role: "Concierge", text: "Sorry, I'm briefly unavailable — please try again in a moment." }]);
    } finally { setSending(false); }
  };

  return (
    <>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="support-bot-toggle"
        aria-label="Open fan concierge chat"
        className="fixed bottom-20 right-4 z-[65] flex h-14 w-14 items-center justify-center rounded-full gold-bg text-white shadow-2xl glow-pink transition-transform hover:scale-110 xl:bottom-6"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>

      {open && (
        <div data-testid="support-bot-panel"
          className="fixed bottom-36 right-4 z-[65] flex h-[460px] w-[92vw] max-w-sm flex-col overflow-hidden rounded-2xl glass-strong shadow-2xl xl:bottom-24">
          <div className="flex items-center gap-2 border-b border-gold/20 p-4">
            <span className="flex h-8 w-8 items-center justify-center rounded-full gold-bg text-white"><Sparkles className="h-4 w-4" /></span>
            <div><p className="text-sm font-display text-amber-50">Fan Concierge</p><p className="text-[0.6rem] text-emerald-accent">● Online · AI assistant</p></div>
          </div>
          <div className="flex-1 space-y-3 overflow-y-auto p-4">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "Fan" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${m.role === "Fan" ? "gold-bg text-white" : "border border-gold/20 bg-obsidian text-amber-100/90"}`}>{m.text}</div>
              </div>
            ))}
            {sending && <div className="flex justify-start"><div className="rounded-2xl border border-gold/20 bg-obsidian px-3 py-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /></div></div>}
            <div ref={endRef} />
          </div>
          <form onSubmit={send} className="flex gap-2 border-t border-gold/20 p-3">
            <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask about voting, tickets…" data-testid="support-bot-input"
              className="flex-1 rounded-full border border-gold/25 bg-obsidian px-4 py-2 text-sm text-amber-50 outline-none focus:border-gold" />
            <button disabled={sending} data-testid="support-bot-send" className="flex h-9 w-9 items-center justify-center rounded-full gold-bg text-white disabled:opacity-50"><Send className="h-4 w-4" /></button>
          </form>
        </div>
      )}
    </>
  );
}
